import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const links = [
    { label: "Services", id: "services" },
    { label: "How we do it", id: "how-we-do-it" },
    { label: "Pricing", id: "pricing" },
    { label: "Case study", id: "case-study" },
    { label: "About", id: "about" },
    { label: "Testimonials", id: "testimonials" },
    { label: "FAQ", id: "faq" },
];

export const Nav = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const onHome = location.pathname === "/creator-program";

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTo = (id) => {
        setOpen(false);
        if (onHome) {
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            navigate(`/creator-program#${id}`);
        }
    };

    const onLogoClick = () => {
        if (onHome) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            navigate("/creator-program");
        }
    };

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-white/85 backdrop-blur-xl border-b border-black/5"
                    : "bg-transparent"
            }`}
        >
            <div className="container-page flex items-center justify-between h-16 md:h-20 gap-4">
                <button
                    data-testid="nav-logo"
                    onClick={onLogoClick}
                    className="flex items-center gap-2 group flex-none"
                >
                    <div className="w-8 h-8 rounded-lg bg-[#0A0A0A] flex items-center justify-center">
                        <span className="font-display font-extrabold text-white text-sm leading-none">
                            AV
                        </span>
                    </div>
                    <span className="font-display font-bold text-[15px] tracking-tight">
                        Consultation
                    </span>
                </button>

                <nav className="hidden lg:flex items-center gap-0.5">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => scrollTo(l.id)}
                            className="px-2.5 py-2 text-[13.5px] text-gray-600 hover:text-[#0A0A0A] transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <div className="flex items-center gap-2 flex-none">
                    <button
                        data-testid="nav-cta-strategy-call"
                        onClick={() => scrollTo("final-cta")}
                        className="rounded-full bg-[#0A0A0A] hover:bg-black text-white h-10 px-5 text-sm font-medium transition-colors whitespace-nowrap"
                    >
                        Book a Strategy Call
                    </button>
                    <button
                        data-testid="nav-mobile-toggle"
                        aria-label="Open menu"
                        onClick={() => setOpen((o) => !o)}
                        className="lg:hidden p-2 -mr-2 text-[#0A0A0A]"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                        >
                            {open ? (
                                <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
                            ) : (
                                <>
                                    <line x1="3" y1="8" x2="21" y2="8" />
                                    <line x1="3" y1="16" x2="21" y2="16" />
                                </>
                            )}
                        </svg>
                    </button>
                </div>
            </div>
            {open && (
                <div className="lg:hidden border-t border-black/5 bg-white">
                    <div className="container-page py-4 flex flex-col">
                        {links.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`nav-mobile-link-${l.id}`}
                                onClick={() => scrollTo(l.id)}
                                className="py-3 text-left text-sm text-gray-700 border-b border-black/5"
                            >
                                {l.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Nav;
